import React, {  useContext } from 'react';
import {Row, Col} from 'react-bootstrap'
import Select from 'react-select';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { GlobalContext } from "../../handlers/GlobalContext";
import { Cookies, getCookieConsentValue } from "react-cookie-consent";


class Register extends React.Component {
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.translate = this.translate.bind(this);
        this.resetSelection = props.reset;

        this.state = {
            country: {value: -1},
            language: {value: -1}
        }
    }

    componentWillMount(){
        this.countries = this.context[0].locale.countries.map((c) => { return { value: c.countryId, label: this.translate(c.element)} });
        this.languages = this.context[0].locale.languages.map((l) => { return { value: l.languageId, label: this.translate(l.element)} });
    }

    //handleSubmit( values, { setSubmitting } ){
    handleSubmit( values, actions ){
        if(!getCookieConsentValue()){
            actions.setFieldError('message', this.translate('cookie-consent-not-accepted','To continue using the application, you need to consent to the use of functional cookies at the bottom of the page.'));
            actions.setSubmitting(false);
            return;
        }

        //Terms and conditions & Privacy Policy

        let fPayload = {
            "Name": values.firstname,
            "Surname": values.lastname,
            "Email": values.email,
            "Password": values.password,
            "UserName": values.username,
            "Country": values.country.value,
            "DefaultLanguage": values.language.value
        }

        let dispatch = this.context[1];
        dispatch({ type: 'REGISTER', payload: fPayload })
            .then(() => {
                let registerErrorMessage = !!this.context[0].error ? this.context[0].error.data : undefined; //.message
                if(!!registerErrorMessage) {
                    actions.setFieldError('message', this.translate(registerErrorMessage));
                    actions.setFieldValue('password', '', false);
                    actions.setFieldValue('password_repeat', '', false);
                    actions.setSubmitting(false);
                } else {
                    if(!!this.context[0].message) {
                        alert(this.translate(this.context[0].message));
                    }
                    actions.setSubmitting(false);
                    this.resetSelection();
                    // actions.setFieldValue('email', '', false);
                    // actions.setFieldValue('username', '', false);
                    // actions.setFieldValue('firstname', '', false);
                    // actions.setFieldValue('lastname', '', false);
                    // actions.setFieldValue('password', '', false);
                    // actions.setFieldValue('password_repeat', '', false);
                    // actions.setFieldValue('country', '', -1);
                    // actions.setFieldValue('language', '', -1);
                }
            });
    }

    handleChange = ( field, values ) => {
        this.state[field] = values
    }
    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.state['toc'] = value
    }

    selection = {};

    translate = (term, alt) => {
        return this.context[0].locale.translation[term] || alt || term;
    }

    render(){
        return(
            <div className="login-wrap text-center col">
                <h3>{ this.translate("register-title-register","Register")}</h3>

                <Formik
                    initialValues={{ email: '', username: '', password: '', password_repeat: '', firstname: '', lastname: '', country: this.state.country, language: -1, message: '' }}
                    validate={values => {
                        const errors = {};
                        if (!values.username) {
                            errors.username = this.translate('register-error-usernameRequired','Username required!');
                        }
                        if (!values.password) {
                            errors.password = this.translate('register-error-emptyPassword','Password cannot be empty!');
                        }
                        if (!!values.password && values.password.length < 6 || values.password.toLowerCase() === values.password || !/\d/.test(values.password) ) {
                            errors.password = this.translate('register-error-simplePassword','Password cannot be less than 6 characters and should contain at least one number and one capital letter!');
                        }
                        if (!!values.password && !!values.password_repeat && values.password !== values.password_repeat) {
                            errors.password_repeat = this.translate('register-error-mismatchPassword','Repeated password does not match previously entered password!');
                        }
                        if ( !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email) ) {
                            errors.email = this.translate('register-error-invalidEmail','Invalid email address');
                        }
                        if (!values.firstname) {
                            errors.firstname = this.translate('register-error-firstNameRequired','First name is required!');
                        }
                        if (!values.lastname) {
                            errors.lastname = this.translate('register-error-lastNameRequired','Last name is required!');
                        }

                        values.country = this.state.country;
                        if (values.country.value == -1) {
                            errors.country = this.translate('register-error-emptyCountry','Please select a country!');
                        }
                        values.language = this.state.language;
                        if (values.language.value == -1) {
                            errors.language = this.translate('register-error-emptyLanguage','Please select a default language!');
                        }
                        values.toc = this.state.toc;
                        if (!values.toc) {
                            errors.toc = this.translate('register-error-nontoc','The agreement is required!');
                        }
                        // if (!!values.message){
                        //     errors.message = values.message;
                        // }
                        // else if (
                        //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                        // ) {
                        //     errors.email = 'Invalid email address';
                        // }
                        return errors;
                    }}
                    onSubmit= { this.handleSubmit }
                >
                    {({ isSubmitting }) => (
                        <Form className="login-form">
                            <ErrorMessage name="message" component="div" className="error-field" />
                            <Row>
                                <Col lg={6}>
                                    <Field type="email" name="email" placeholder={this.translate("register-placeholder-email", "E-mail")}/>
                                    <ErrorMessage name="email" component="div" className="error-field"/>
                                    <Field type="text" name="username" className="formField" placeholder={this.translate("register-placeholder-username", "Username")} />
                                    <ErrorMessage name="username" component="div" className="error-field" />
                                    <Field type="password" name="password" placeholder={this.translate("register-placeholder-password", "Password")} />
                                    <ErrorMessage name="password" component="div" className="error-field" />
                                    <Field type="password" name="password_repeat" placeholder={this.translate("register-placeholder-passwordRepeat", "Password (Repeat)")} />
                                    <ErrorMessage name="password_repeat" component="div" className="error-field" />
                                </Col>
                                <Col lg={6}>
                                    <Field type="text" name="firstname" className="formField" placeholder={this.translate("register-placeholder-firstName", "First name")} />
                                    <ErrorMessage name="firstname" component="div" className="error-field" />
                                    <Field type="text" name="lastname" className="formField" placeholder={this.translate("register-placeholder-lastName", "Last name")} />
                                    <ErrorMessage name="lastname" component="div" className="error-field" />
                                    <Select
                                        className={"input-select"}
                                        menuPlacement={'auto'}
                                        name="country"
                                        options={this.countries}
                                        multi={false}
                                        onChange={this.handleChange.bind(this,"country")}
                                        value={this.selection.country}
                                        placeholder={this.translate("register-placeholder-country", "Country")}
                                    />
                                    <ErrorMessage name="country" component="div" className="error-field" />
                                    <Select
                                        className={"input-select"}
                                        menuPlacement={'auto'}
                                        name="language"
                                        options={this.languages}
                                        multi={false}
                                        onChange={this.handleChange.bind(this,"language")}
                                        value={this.selection.language}
                                        placeholder={this.translate("register-placeholder-language", "Default language")}
                                    />
                                    <ErrorMessage name="language" component="div" className="error-field" />
                                </Col>
                                <Col lg={12}>
                                    <div>
                                        <label>
                                            <input
                                                className={'checkbox-input'}
                                                type="checkbox"
                                                onChange={this.handleCheckboxChange}
                                            />
                                                { this.translate('toc_pp_consent','I understand and agree to the') }&nbsp;
                                                <a href="/terms_and_conditions.html" target="_blank">{this.translate('toc_text', 'Terms and Conditions')}</a>/
                                                <a href="/privacy_policy.html" target="_blank">{this.translate('pp_text', 'Privacy Policy')}</a>
                                        </label>
                                        <ErrorMessage name="toc" component="div" className="error-field"/>
                                    </div>

                                </Col>
                            </Row>


                            <button type="submit" disabled={isSubmitting}>
                                {this.translate("register-button-submit", "Submit")}
                            </button>
                            <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.resetSelection(true)} }>
                                {this.translate("register-button-back", "Back")}
                            </button>
                        </Form>
                    )}
                </Formik>

            </div>
        );
    }
}

Register.contextType = GlobalContext;
export default Register;